export const get_input_success = 'get_input_success'
export const input_table_off = 'input_table_off'

